
const changeAttributesOfInputs = (index, parentEl, attrName) => {
    const childEls = parentEl.querySelectorAll(`[${attrName}]`)
    Array.from(childEls).forEach((childEl) => {
        const attrValue = childEl.getAttribute(attrName)
        childEl.setAttribute(attrName, `${attrValue}-${index}`)
    })
}


export const changeMultipleAttributesOfInputs = (number, el) => {
    changeAttributesOfInputs(number, el, 'name')
    changeAttributesOfInputs(number, el, 'id')
    changeAttributesOfInputs(number, el, 'for')
    changeAttributesOfInputs(number, el, 'data-next-tab')
}